import { IssueStatusType } from '@kcftech/prometheustypescriptapiclient';
import { StatusLozenge } from 'pages/Desk/issues/StatusLozenge';
import { useMemo } from 'react';
import { MultiSelectQuickFilterButton } from 'shared/filter_pane/MultiSelectQuickFilterButton';
import { sortBy } from 'utils/array';

export type StatusFilterButtonProps = {
    statuses: IssueStatusType[];
    onChangeStatuses: (statuses: IssueStatusType[]) => void;
};

export function StatusFilterButton({
    statuses,
    onChangeStatuses,
}: StatusFilterButtonProps) {
    const options = useMemo(
        () =>
            sortBy(Object.values(IssueStatusType), (s) => s).map((status) => ({
                value: status,
                label: <StatusLozenge status={status} />,
            })),
        []
    );

    return (
        <MultiSelectQuickFilterButton
            id="status-filter"
            label="Status"
            selectedValues={statuses}
            onChangeValues={onChangeStatuses}
            options={options}
        />
    );
}
